import { BrowserStorage } from '@estee/elc-universal-utils';

interface IAppSrc {
  src?: string;
}

const checkoutAppName = 'elc-react-checkout-app';

const replaceWebpackDynamicImport = (originalSrc: string): string => {
  // take the path for elc-react-checkout-app script and use it
  // to load the chunks from the correct path

  // for local dev build used by personal server
  const localBuildPath = BrowserStorage.getCookie('LOCAL_DEVEL');
  if (localBuildPath) {
    const { origin } = new URL(localBuildPath);
    return origin + originalSrc;
  }

  // for PROD, DEV
  const appSrc: IAppSrc = document.querySelector(`script[src*="${checkoutAppName}"]`) as IAppSrc;
  if (appSrc && appSrc.src) {
    const { pathname } = new URL(appSrc.src);
    const appIndex = pathname.indexOf(checkoutAppName);
    // script.src may be a chunk src
    const nextSlashIndex = pathname.indexOf('/', appIndex + checkoutAppName.length + 1);
    const cdnPathname = nextSlashIndex === -1 ? pathname : pathname.substring(0, nextSlashIndex);

    // for preprod testing
    const envOrigin = BrowserStorage.getCookie('WWWTMP_DEVEL');
    if (envOrigin) {
      const { origin } = new URL(envOrigin);
      return `${origin}${cdnPathname}${originalSrc}`;
    }

    return `${cdnPathname}${originalSrc}`;
  }


  // for production build deployed on personal server
  if (originalSrc.indexOf('shared/acac_blackbox') === -1) {
    const appPersonalServerSrc: IAppSrc = document.querySelector('script[src*="shared/acac_blackbox/bundle.js"]') as IAppSrc;
    if (appPersonalServerSrc && appPersonalServerSrc.src) {
      const { pathname } = new URL(appPersonalServerSrc.src);
      return pathname.replace('bundle.js', originalSrc);
    }
  }

  return originalSrc;
};

export default replaceWebpackDynamicImport;
